import { render, staticRenderFns } from "./AlgorithmFailedJobsPanel.vue?vue&type=template&id=9820b4be&scoped=true"
import script from "./AlgorithmFailedJobsPanel.vue?vue&type=script&lang=js"
export * from "./AlgorithmFailedJobsPanel.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmFailedJobsPanel.vue?vue&type=style&index=0&id=9820b4be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9820b4be",
  null
  
)

export default component.exports